import React, { useEffect, useContext } from "react";
import useState from "react-usestateref";
import Header from "./Header";
import Sidebar from "./Sidebar";
import Select from "react-select";
import { UserContext } from "../contexts/UserContext";
import { getUserDetails } from "../services/authservices";
import authService from "../services/authservices";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { verifyTFA } from "../services/authservices";
import dayjs from "dayjs";
import { ScaleLoader } from "react-spinners";
import service from "../services/authservices";
import { useTranslation } from "react-i18next";
import i18n from "../translate/i18n";

function Withdraw() {
  const { t } = useTranslation();

  const [i18nextLngs, seti18nextLngs] = useState(
    localStorage.getItem("i18nextLng") || "en" || "et" || "fi"
  );

  useEffect(() => {
    if (i18nextLngs === "en") {
      i18n.changeLanguage(i18nextLngs);
      document.documentElement.lang = i18nextLngs;
      // localStorage.setItem("i18nextLng", i18nextLngs);
    }
  }, [i18nextLngs]);

  const navigate = useNavigate();
  const [amount, setAmount, amountref] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [timer, setTimer] = useState(300);
  const [emailOtp, setEmailOtp, emailOtpref] = useState("");
  const [tfaCode, setTfaCode, tfaCoderef] = useState("");
  const [coinType, setCoinType, coinTyperef] = useState("");
  const [addressOptions, setAddressOptions] = useState([]);
  const [selectedAddress, setSelectedAddress, selectedAddressref] =
    useState(null);
  const [label, setLabel] = useState("");
  const [network, setNetwork, networkref] = useState("");
  const [addressData, setAddressData] = useState(null);
  const [resendLoader, setResendLoader] = useState(false);
  const [buttonLoader, setbuttonLoader] = useState(false);
  const [input, setInput] = useState("");
  const [faqs, setFaqs] = useState({});
  const [errors, setErrors] = useState({});
  const { theme } = useContext(UserContext);
  const [activeIndex, setActiveIndex] = useState(null);
  const [currencyOptions, setcurrencyOptions] = useState([]);

  const fetchCurrencies = async () => {
    try {
      const data = await service.getWithdrawCurrency();
      var currency_data = [];
      for (let index = 0; index < data.get_currency.length; index++) {
        const element = data.get_currency[index];
        var obj = {
          value: element.currencySymbol,
          label: element.currencySymbol,
          text: element.currencySymbol,
        };
        currency_data.push(obj);
      }
      setcurrencyOptions(currency_data);
    } catch (err) {
      // console.log(err);
    }
  };

  const select_currency = (value) => {
    coinTyperef.current = value;
    fetchWithdrawDetails(value);
    fetchAddresses(coinTyperef.current, networkref.current);
  };

  useEffect(() => {
    const fetchFaqs = async () => {
      try {
        const response = await authService.getFaq();
        if (response.status) {
          // Filter FAQs with type 'Withdraw' only
          const withdrawFaqs = response.data.filter(
            (faq) => faq.type === "Withdraw"
          );
          setFaqs(withdrawFaqs); // Store filtered FAQs directly
        } else {
          console.error("Failed to fetch FAQs");
        }
      } catch (error) {
        console.error("Error fetching FAQs:", error);
      }
    };

    fetchFaqs();
    fetchCurrencies();
  }, []);

  const handleToggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const [user, setUser] = useState({
    tfaStatus: 0,
    email: null,
    uid: null,
    referralCode: null,
    referralUrl: null,
    displayname: null,
    country: null,
    isAuthenticated: false,
  });
  const [loading, setLoading] = useState(true);
  const [toastVisible, setToastVisible] = useState(false);

  const showErrorToast = (message) => {
    if (!toastVisible) {
      setToastVisible(true); // Set toast as visible
      toast.error(
        <div className="toast-ml">
          <h4 className="toast-title">Error!</h4>
          <p className="toast-message">{message}</p>
        </div>,
        {
          onClose: () => setToastVisible(false), // Reset toastVisible on close
          autoClose: 3000, // Optional: auto-close after 3 seconds
        }
      );
    }
  };

  const showSuccessToast = (message) => {
    if (!toastVisible) {
      setToastVisible(true);
      toast.success(
        <div className="toast-ml">
          <h4 className="toast-title">Success!</h4>
          <p className="toast-message">{message}</p>
        </div>,
        {
          onClose: () => setToastVisible(false), // Reset state on close
          autoClose: 3000, // Auto-close after 3 seconds
        }
      );
    }
  };
  const fetchUserDetails = async () => {
    const token = localStorage.getItem("token");
    if (token) {
      try {
        const data = await authService.getUserDetails(token);
        if (data && data.status) {
          const userDetails = {
            isAuthenticated: true,
            tfaStatus: data.tfastatus,
            email: data.email,
            displayname: data.displayname,
            country: data.country,
            uid: data.uid,
            referralCode: data.referralCode,
            referralUrl: data.referralUrl,
          };
          setUser(userDetails);
        } else {
          setUser({
            isAuthenticated: false,
            tfaStatus: 0,
            email: null,
            uid: null,
            referralCode: null,
            referralUrl: null,
          });
        }
      } catch (error) {
        console.error("Error fetching user details:", error);
        setUser({
          isAuthenticated: false,
          tfaStatus: 0,
          email: null,
          uid: null,
          referralCode: null,
          referralUrl: null,
        });
      }
    } else {
      setUser({
        isAuthenticated: false,
        tfaStatus: 0,
        email: null,
        uid: null,
        referralCode: null,
        referralUrl: null,
      });
    }
    setLoading(false);
  };

  const setcoin = (value) => {
    setCoinType(value);
    setNetwork("");
    setSelectedAddress(null);
    setAmount("");
    setEmailOtp("");
    setTfaCode("");
    setErrors({});
  };

  useEffect(() => {
    fetchUserDetails();
  }, []);
  const handleCopy = (txID) => {
    if (handleCopy.timeout) clearTimeout(handleCopy.timeout);

    handleCopy.timeout = setTimeout(() => {
      if (handleCopy.toastVisible) return;

      handleCopy.toastVisible = true;

      navigator.clipboard
        .writeText(txID)
        .then(() => {
          showsuccessToast(
            <div className="toast-ml">
              <h4 className="toast-title">Success!</h4>
              <p className="toast-message">
                Transaction ID copied to clipboard!
              </p>
            </div>
          );
        })
        .catch((err) => {
          console.error("Failed to copy text: ", err);
          showerrorToast(
            <div className="toast-ml">
              <h4 className="toast-title">Error!</h4>
              <p className="toast-message">Failed to copy Transaction ID</p>
            </div>
          );
        })
        .finally(() => {
          setTimeout(() => {
            handleCopy.toastVisible = false;
          }, 2000);
        });
    }, 300);
  };

  const [withdrawDetails, setWithdrawDetails] = useState({
    minWithdraw: 0,
    maxWithdraw: 0,
    availableBalance: 0,
    fees: 0,
  });
  // useEffect(() => {fetchWithdrawDetails();
  // }, [coinType]);

  const fetchWithdrawDetails = async () => {
    const result = await authService.getWithdrawDetails(coinTyperef.current);
    if (result) {
      setWithdrawDetails({
        minWithdraw: result.data.minWithdrawLimit,
        maxWithdraw: result.data.maxWithdrawLimit,
        availableBalance: result.data.balance,
        fees: result.data.withdrawFee,
      });
      // setNetwork(null);
    } else {
      console.error("Failed to fetch withdrawal details:", result.message);
    }
  };
  const truncateText = (text, maxLength) => {
    if (!text || typeof text !== "string") {
      return "--";
    }
    if (text.length > maxLength) {
      return text.substring(0, maxLength) + " . . .";
    }
    return text;
  };
  const customStyles = {
    control: (styles) => ({
      ...styles,
      // backgroundColor: "#f9f9f9",
      // border: "1px solid #ccc",
      // padding: "4px",
      backgroundColor: theme === "dark" ? "transparent" : "#f9f9f9",
      border: `1px solid ${theme === "dark" ? "#2b3139" : "#ccc"}`,
      padding: "4px",
      color: theme === "dark" ? "#fff" : "#000",
      //   border: "none",
      boxShadow: "none", // Removes the box-shadow
      outline: "none", // Removes any outline
      fontSize: window.innerWidth < 400 ? "12px" : "16px",
    }),
    option: (styles, { isFocused }) => ({
      ...styles,
      color: theme === "dark" ? "#fff" : "#000",
      backgroundColor: isFocused
        ? theme === "dark"
          ? "#444"
          : "#e0e0e0"
        : theme === "dark"
        ? "#181a20"
        : "#fff",
      cursor: "pointer",
      fontSize: window.innerWidth < 400 ? "12px" : "16px",
    }),
    singleValue: (styles) => ({
      ...styles,
      color: theme === "dark" ? "#fff" : "#000",
      fontSize: window.innerWidth < 400 ? "12px" : "16px",
    }),
  };

  useEffect(() => {
    fetchAddresses(coinTyperef.current, networkref.current);
  }, [coinTyperef.current, networkref.current]);

  const fetchAddresses = async (coinType, network) => {
    const result = await authService.getWithdrawAddresses();
    const filteredAddresses = result.data.filter(
      (address) => address.token === coinType && address.network === network
    );
    const formattedAddresses = filteredAddresses.map((address) => ({
      value: address.address,
      label: address.label || address.address,
      token: address.token,
      network: address.network,
    }));

    setAddressOptions(formattedAddresses);
    setSelectedAddress(null);
  };
  const [withdrawalHistory, setWithdrawalHistory] = useState([]);

  useEffect(() => {
    const fetchWithdrawalHistory = async () => {
      const response = await authService.getWithdrawalHistory();
      if (response.status) {
        setWithdrawalHistory(response.data);
      } else {
        console.error("Failed to fetch withdrawal history:", response.Message);
      }
    };

    fetchWithdrawalHistory();
  }, []);

  const handlechange = () => {
    navigate("/security-tfa");
  };
  // const handleSelectChange = (selectedOption) => {
  //   setSelectedAddress(selectedOption);
  //   validate();
  // };

  const customFilter = (option, inputValue) => {
    const sanitizedInput = inputValue.trim().toLowerCase();
    const label = option.label.toLowerCase();
    const address = option.value.toLowerCase();
    const labelMatch = label.includes(sanitizedInput);
    const addressMatch = address.includes(sanitizedInput);
    return labelMatch || addressMatch;
  };
  const handleKeyDown = (e) => {
    if (e.key === " " && !e.ctrlKey && !e.metaKey) {
      e.preventDefault();
    }
  };

  const handleKeyDownDropdown = (e, type) => {
    if (type === "withdraw") {
      if (
        e.key === "Backspace" ||
        e.key === "Delete" ||
        e.key === "Tab" ||
        e.key === "ArrowLeft" ||
        e.key === "ArrowRight"
      ) {
        return;
      }

      if (e.target.value.length >= 70) {
        e.preventDefault();
      }

      if (!/^[a-zA-Z0-9]$/.test(e.key)) {
        e.preventDefault();
      }
    }
  };
  const handleKeyDown2 = (e) => {
    const allowedKeys = [
      "Backspace", // Allow deleting with Backspace
      "Delete", // Allow deleting with Delete
      "ArrowLeft", // Allow moving left
      "ArrowRight", // Allow moving right
      "Tab", // Allow tabbing
    ];

    // Allow numbers, one decimal point, and the allowed keys
    if (
      (!/[0-9.]/.test(e.key) && !allowedKeys.includes(e.key)) ||
      (e.key === "." && e.target.value.includes(".")) ||
      e.key === " " // Disallow spaces
    ) {
      e.preventDefault();
    }
  };

  const handleWithdrawSubmit = async () => {
    let errros = validate();
    if (Object.keys(errros).length > 0) {
      return setErrors(errros);
    }
    // if (!amount || !selectedAddress || !emailOtp || !tfaCode) {
    //   toast.error("Please fill all required fields.");
    //   return;
    // }
    setbuttonLoader(true);
    const otpResponse = await authService.verifywithdrawmainOtp({
      withdrawOtp: Number(emailOtpref.current),
    });
    if (!otpResponse.status) {
      setbuttonLoader(false);
      showerrorToast(
        <div className="toast-ml">
          <h4 className="toast-title">Error!</h4>
          <p className="toast-message">{otpResponse.Message}</p>
        </div>
      );
      return;
    }

    // toast.success(otpResponse.Message);
    const token = localStorage.getItem("token");
    const tfaResponse = await verifyTFA(user.email, Number(tfaCoderef.current));
    if (tfaResponse.status == 200) {
      setbuttonLoader(false);
      toast.success(
        <div className="toast-ml">
          <h4 className="toast-title">Success!</h4>
          <p className="toast-message">{tfaResponse.Message}</p>
        </div>
      );
    }
    if (!tfaResponse.status) {
      setbuttonLoader(false);
      showerrorToast(
        <div className="toast-ml">
          <h4 className="toast-title">Error!</h4>
          <p className="toast-message">{tfaResponse.Message}</p>
        </div>
      );
      return;
    }

    const numericAmount = parseFloat(amountref.current);
    if (numericAmount < withdrawDetails.minWithdraw) {
      setbuttonLoader(false);
      showerrorToast(
        <div className="toast-ml">
          <h4 className="toast-title">Error!</h4>
          <p className="toast-message">
            Amount must be at least ${withdrawDetails.minWithdraw.toFixed(6)}.
          </p>
        </div>
      );
      return;
    }
    if (numericAmount > withdrawDetails.maxWithdraw) {
      setbuttonLoader(false);
      showerrorToast(
        <div className="toast-ml">
          <h4 className="toast-title">Error!</h4>
          <p className="toast-message">
            Amount must not exceed ${withdrawDetails.maxWithdraw.toFixed(6)}.
          </p>
        </div>
      );
      return;
    }
    if (numericAmount > withdrawDetails.availableBalance) {
      setbuttonLoader(false);
      showerrorToast(
        <div className="toast-ml">
          <h4 className="toast-title">Error!</h4>
          <p className="toast-message">Insufficient balance.</p>
        </div>
      );
      return;
    }
    // const amountsubmit = amountref.current;
    // const otpsubmit = emailOtpref.current;
    // const tfasubmit = tfaCoderef.current;
    // const networksubmit = networkref.current;

    const requestData = {
      amount: amountref.current,
      address: selectedAddressref.current.value,
      currency_symbol: coinTyperef.current,
      emailOtp: emailOtpref.current,
      tfaCode: tfaCoderef.current,
      network: networkref.current,
    };
    // console.log("withdraw requestData", requestData);
    try {
      const response = await authService.withdrawSubmit(requestData);
      if (response.status) {
        setbuttonLoader(false);
        showsuccessToast(
          <div className="toast-ml">
            <h4 className="toast-title">Success!</h4>
            <p className="toast-message">{response.Message}</p>
          </div>
        );
        setAmount("");
        setTfaCode("");
        setAddressData("");
        setNetwork("BEP20");
        setEmailOtp("");
      } else {
        setbuttonLoader(false);
        showerrorToast(
          <div className="toast-ml">
            <h4 className="toast-title">Error!</h4>
            <p className="toast-message">{response.Message}</p>
          </div>
        );
      }
    } catch (error) {
      setbuttonLoader(false);
      showerrorToast(
        <div className="toast-ml">
          <h4 className="toast-title">Error!</h4>
          <p className="toast-message">
            An error occurred while processing the request.
          </p>
        </div>
      );
    }
  };

  const sendOtp = async () => {
    setResendLoader(true);
    if (!user.email) {
      setResendLoader(false);
      showerrorToast(
        <div className="toast-ml">
          <h4 className="toast-title">Error!</h4>
          <p className="toast-message">
            User email is not available. Please try again.
          </p>
        </div>
      );
      return;
    }
    if (
      errors.network ||
      errors.address ||
      errors.amount ||
      !networkref.current ||
      !selectedAddressref ||
      !amountref.current
    ) {
      setResendLoader(false);
      showerrorToast(
        <div className="toast-ml">
          <h4 className="toast-title">Error!</h4>
          <p className="toast-message">
            Please fill all fields before sending OTP.
          </p>
        </div>
      );
      return;
    }

    try {
      const response = await authService.withdrawOtp({ email: user.email });
      if (response.status) {
        setResendLoader(false);
        showsuccessToast(
          <div className="toast-ml">
            <h4 className="toast-title">Success!</h4>
            <p className="toast-message">OTP sent successfully!</p>
          </div>
        );
        setOtpSent(true);
        setTimer(300);
      } else {
        setResendLoader(false);
        showerrorToast(
          <div className="toast-ml">
            <h4 className="toast-title">Error!</h4>
            <p className="toast-message">
              {response.Message
                ? response.Message
                : "Failed to send OTP. Please try again."}
            </p>
          </div>
        );
      }
    } catch (error) {
      setResendLoader(false);
      showerrorToast(
        <div className="toast-ml">
          <h4 className="toast-title">Error!</h4>
          <p className="toast-message">An error occurred. Please try again.</p>
        </div>
      );
    }
  };

  // const handleNetworkChange = (selectedOption) => {
  //   setNetwork(selectedOption ? selectedOption.value : null);
  //   setSelectedAddress(null);
  //   setAmount("");
  //   setEmailOtp("");
  //   setTfaCode("");
  //   validate();
  // };

  // const validate = (values) => {
  //   console.log("emailOtpref-->",emailOtpref.current);
  //   let newerrors = {};
  //   if(!networkref.current){
  //     newerrors.network = "Network is a required field";
  //   }
  //   if(!selectedAddressref.current){
  //     newerrors.address = "Address is a required field";
  //   }
  //   if(!amountref.current){
  //     newerrors.amount = "Amount is a required field";
  //   }
  //   if(!emailOtpref.current){
  //     newerrors.otp = "OTP is a required field";
  //   }
  //   if(!tfaCoderef.current){
  //     newerrors.tfa = "TFA is a required field";
  //   }

  //   setErrors(newerrors);
  //   return newerrors;
  // }

  const handleNetworkChange = (selectedOption) => {
    setNetwork(selectedOption ? selectedOption.value : null);
    validate("network", selectedOption ? selectedOption.value : null);
    fetchAddresses(coinTyperef.current, selectedOption);
  };

  const handleSelectChange = (selectedOption) => {
    setSelectedAddress(selectedOption);
    validate("address", selectedOption);
  };

  const handleAmountChange = (e) => {
    const value = e.target.value;
    setAmount(value);
    validate("amount", value);
  };

  const handleEmailOtpChange = (e) => {
    const value = e.target.value;
    if (value.length <= 6) {
      setEmailOtp(value);
      validate("otp", value);
    }
  };

  const handleTfaCodeChange = (e) => {
    const value = e.target.value;
    if (value.length <= 6) {
      setTfaCode(value);
      validate("tfa", value);
    }
  };

  const validate = (fieldName = null, value = null) => {
    let newErrors = { ...errors };

    if (!fieldName || fieldName === "network") {
      if (!networkref.current) {
        newErrors.network = "Network is a required field";
      } else {
        delete newErrors.network;
      }
    }

    if (!fieldName || fieldName === "address") {
      if (!selectedAddressref.current) {
        newErrors.address = "Address is a required field";
      } else {
        delete newErrors.address;
      }
    }

    if (!fieldName || fieldName === "amount") {
      if (
        !amountref.current ||
        isNaN(amountref.current) ||
        Number(amountref.current) <= 0
      ) {
        newErrors.amount = "Amount is a required field";
      } else {
        delete newErrors.amount;
      }
    }

    if (!fieldName || fieldName === "otp") {
      if (!emailOtpref.current) {
        newErrors.otp = "OTP is required";
      } else if (emailOtpref.current.length !== 6) {
        newErrors.otp = "OTP must be 6 digits";
      } else {
        delete newErrors.otp;
      }
    }

    if (!fieldName || fieldName === "tfa") {
      if (!tfaCoderef.current) {
        newErrors.tfa = "TFA is required";
      } else if (tfaCoderef.current.length !== 6) {
        newErrors.tfa = "TFA must be 6 digits";
      } else {
        delete newErrors.tfa;
      }
    }

    setErrors(newErrors);
    return newErrors;
  };

  const NetworkOptions = [
    { value: "TRC20", label: "TRC20" },
    { value: "BEP20", label: "BEP20" },
    // { value: "Matic", label: "MATIC" },
  ];

  const networkOptions_usdt = [
    { value: "BEP20", label: "BEP20" },
    // { value: "Matic", label: "MATIC" },
  ];

  useEffect(() => {
    let countdown;
    if (otpSent && timer > 0) {
      countdown = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    } else if (timer === 0) {
      setOtpSent(false);
      clearInterval(countdown);
    }
    return () => clearInterval(countdown);
  }, [timer, otpSent]);

  useEffect(() => {
    setSelectedAddress(null);
  }, [coinType]);

  const showsuccessToast = (message) => {
    toast.dismiss();
    toast.success(message);
  };

  const showerrorToast = (message) => {
    toast.dismiss();
    toast.error(message);
  };

  const max = (e) => {
    const value = withdrawDetails.availableBalance;
    // console.log("max value =====", value);
    setAmount(value);
    validate("amount", value);
  };

  return (
    <div>
      <section>
        <Header />
      </section>
      <div className="withdraw-section">
        <div className="container">
          <div className="row prof_row_sm">
            <div className="col-lg-3 dispaly_none_1200">
              <Sidebar />
            </div>
            <div className="col-xl-9 col-lg-12 deposit_pad_top">
              <span className="profile_span">{t("Withdraw1")}</span>
              <div className="row mt-4">
                <div className="col-lg-7">
                  <div className="deposit_left_main">
                    <div className="depo_inner_divmain">
                      <span className="home-viewasset-span">
                        {t("SelectCrypto")}
                      </span>
                      {/* <div className="depo_nav_design">
                        <div
                          className={
                            coinType === "usdt"
                              ? "depo_nav_active"
                              : "depo_nav_notactive"
                          }
                          onClick={() => setcoin("usdt")}
                        >
                          <img
                            src={require("../assests/usdt-logo.png")}
                            alt="usdt"
                            className="logout-img"
                          />
                          <span>usdt</span>
                        </div>
                        <div
                          className={
                            coinType === "usdt"
                              ? "depo_nav_active"
                              : "depo_nav_notactive"
                          }
                          onClick={() => setcoin("usdt")}
                        >
                          <img
                            src={require("../assests/usdt-logo.png")}
                            alt="usdt"
                            className="logout-img"
                          />
                          <span>usdt</span>
                        </div>
                      </div> */}
                      <Select
                        options={currencyOptions}
                        styles={customStyles}
                        // key={dropdownKey}
                        onChange={(e) => select_currency(e.value)}
                        className="withdraw-dropdown-menu"
                      />
                    </div>

                    {coinTyperef.current ? (
                      <>
                        <div className="depo_inner_divmain">
                          <span className="register_spans">{t("Network")}</span>
                          <Select
                            options={
                              coinTyperef.current == "usdt"
                                ? NetworkOptions
                                : networkOptions_usdt
                            }
                            styles={customStyles}
                            placeholder={t("SelectNetwork")}
                            onChange={handleNetworkChange}
                            className="withdraw-dropdown-menu"
                            value={
                              network
                                ? NetworkOptions.find(
                                    (option) => option.value === network
                                  )
                                : null
                            }
                          />
                          {errors && errors.network && (
                            <p className="error">{errors.network}</p>
                          )}
                        </div>
                        <div className="depo_inner_divmain">
                          <div className="manage_btn_row">
                            <span className="home-viewasset-span">
                              {t("WalletAddress")}
                            </span>
                            <Link to="/security-withdraw">
                              <div className="d-flex align-items-center gap-2 cursor-pointer">
                                <span className="home_starty_view">
                                  {" "}
                                  {t("AddAddress")}
                                </span>
                                <i class="fa-solid fa-chevron-right home_starty_viewarrow"></i>
                              </div>
                            </Link>
                          </div>
                          <Select
                            options={addressOptions}
                            styles={customStyles}
                            placeholder={t("SelectOrTypeTheAddress")}
                            className="withdraw-dropdown-menu"
                            onChange={handleSelectChange}
                            value={selectedAddress}
                            isSearchable={true}
                            inputValue={label}
                            defaultInputValue={selectedAddress}
                            getOptionLabel={(e) => `${e.value}`}
                            filterOption={customFilter}
                            onInputChange={(value, action) => {
                              if (action.action === "input-change")
                                setLabel(value);
                            }}
                            onKeyDown={(e) =>
                              handleKeyDownDropdown(e, "withdraw")
                            }
                          />
                          {errors && errors.address && (
                            <p className="error">{errors.address}</p>
                          )}
                        </div>
                        <div className="depo_in_notesdiv">
                          <div className="depoin_notes_icon">
                            <i class="bi bi-exclamation-triangle depo_note_ico"></i>
                          </div>
                          <div className="depo_notes_defspan">{t("Make")}</div>
                        </div>
                        <div className="withdraw_fes_main">
                          <div className="depo_inner_divmain">
                            <span className="home-viewasset-span">
                              {t("WithdrawAmount")}
                            </span>
                            <div className="pos_rel">
                              <input
                                className="withdraw_amnt"
                                placeholder={t("EnterTheAmount")}
                                type="text"
                                value={amount}
                                pattern="[0-9]*"
                                maxLength={8}
                                // onChange={(e) => {
                                //   const value = e.target.value;
                                //   setAmount(value); // Update the state
                                //   validate(value);
                                // }} // Bind amount input
                                onChange={handleAmountChange}
                                onKeyDown={handleKeyDown2}
                                name="amount"
                              />
                              <span className="withdraw_amnt_max" onClick={max}>
                                {t("Max")}
                              </span>
                            </div>
                            {errors && errors.amount && (
                              <p className="error">{errors.amount}</p>
                            )}
                          </div>
                          <div className="depo_inner_divmain">
                            <span className="home-viewasset-span">
                              {t("EnterOTP")}
                            </span>
                            <div className="pos_rel w-100">
                              <input
                                type="number"
                                maxLength="6"
                                min={0}
                                name="emailOtp"
                                value={emailOtpref.current}
                                onKeyDown={(evt) =>
                                  ["e", "E", "+", "-"].includes(evt.key) &&
                                  evt.preventDefault()
                                }
                                // onChange={(e) => {
                                //   const value = e.target.value;
                                //   if (value.length <= 6) {
                                //     setEmailOtp(value);
                                //     validate(value);
                                //   }

                                // }}
                                onChange={handleEmailOtpChange}
                                placeholder={t("EnterTheVerificationCode")}
                                className="bind_bin_next_inp"
                                // onKeyDown={handleKeyDown}
                              />
                              {otpSent ? (
                                <span className="bind_bin_next_inp_Copy">
                                  {t("Resend")} ({timer}s)
                                </span>
                              ) : (
                                <span
                                  className="bind_bin_next_inp_Copy"
                                  onClick={() => sendOtp()}
                                  style={{ cursor: "pointer" }}
                                >
                                  {resendLoader == false ? (
                                    <>{timer === 300 ? "Send OTP" : "Resend"}</>
                                  ) : (
                                    "Loading..."
                                  )}
                                </span>
                              )}
                            </div>
                            {errors && errors.otp && (
                              <p className="error">{errors.otp}</p>
                            )}
                          </div>
                          <div className="depo_inner_divmain">
                            <span className="home-viewasset-span">
                              {t("EnterTFA")}
                            </span>
                            <div className="pos_rel w-100">
                              <input
                                type="number"
                                maxLength="6"
                                min={0}
                                name="tfaCode"
                                value={tfaCoderef.current}
                                onKeyDown={(evt) =>
                                  ["e", "E", "+", "-"].includes(evt.key) &&
                                  evt.preventDefault()
                                }
                                // onChange={(e) => {
                                //   const value = e.target.value;
                                //   if (value.length <= 6) {
                                //   setTfaCode(value); // Update the state
                                //   validate(value);
                                //   }
                                // }}
                                onChange={handleTfaCodeChange}
                                placeholder={t("EnterTheTFAcode")}
                                className="bind_bin_next_inp"
                                // onKeyDown={handleKeyDown}
                              />
                              {errors && errors.tfa && (
                                <p className="error">{errors.tfa}</p>
                              )}
                            </div>
                          </div>
                          <div className="with_draw_feeses">
                            <div className="with_fees_spacebet">
                              <span className="top_startgy_inbottomadvance">
                                {t("Fees")}
                              </span>
                              <span className="home-viewasset-span">
                                {withdrawDetails.fees}%
                              </span>
                            </div>
                            <div className="with_fees_spacebet">
                              <span className="top_startgy_inbottomadvance">
                                {t("Availablebalance")}
                              </span>
                              <span className="home-viewasset-span">
                                {withdrawDetails.availableBalance}
                              </span>
                            </div>
                            <div className="with_fees_spacebet">
                              <span className="top_startgy_inbottomadvance">
                                {t("Minimumwithdraw")}
                              </span>
                              <span className="home-viewasset-span">
                                {withdrawDetails.minWithdraw}
                              </span>
                            </div>
                            <div className="with_fees_spacebet">
                              <span className="top_startgy_inbottomadvance">
                                {t("Maximumwithdraw")}
                              </span>
                              <span className="home-viewasset-span">
                                {withdrawDetails.maxWithdraw}
                              </span>
                            </div>
                          </div>
                        </div>
                        {user.tfaStatus == 0 ? (
                          <div
                            className="withdraw_submit_div"
                            onClick={handlechange}
                          >
                            <span>{t("EnableTFA")}</span>
                          </div>
                        ) : (
                          <>
                            {buttonLoader == false ? (
                              <div
                                className="withdraw_submit_div"
                                onClick={handleWithdrawSubmit}
                              >
                                <span>{t("Submit")}</span>
                              </div>
                            ) : (
                              <div className="withdraw_submit_div">
                                <span>{t("Loading")}</span>
                              </div>
                            )}
                          </>
                        )}
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <div className="col-lg-5">
                  <div className="container m-top-20 p-0">
                    <div
                      className="accordion accordion-flush"
                      id="accordionFlushExample"
                    >
                      <div className="faq">
                        <h5 className="faq-title">{t("FAQs")}</h5>
                        {faqs.length > 0 ? (
                          faqs.map((faq, index) => (
                            <div
                              className="accordion-item font-satoshi"
                              key={faq._id}
                            >
                              <h2
                                className="accordion-header"
                                id={`flush-heading-${index}`}
                              >
                                <button
                                  className={`accordion-button ${
                                    activeIndex === index ? "" : "collapsed"
                                  }`}
                                  type="button"
                                  onClick={() => handleToggle(index)}
                                  aria-expanded={
                                    activeIndex === index ? "true" : "false"
                                  }
                                  aria-controls={`flush-collapse-${index}`}
                                >
                                  {index + 1}. {faq.question}
                                  <span className="icon">
                                    <i
                                      className={`fas ${
                                        activeIndex === index
                                          ? "fa-chevron-up"
                                          : "fa-chevron-down"
                                      }`}
                                    ></i>
                                  </span>
                                </button>
                              </h2>
                              <div
                                id={`flush-collapse-${index}`}
                                className={`accordion-collapse collapse ${
                                  activeIndex === index ? "show" : ""
                                }`}
                                aria-labelledby={`flush-heading-${index}`}
                                data-bs-parent="#accordionFlushExample"
                              >
                                <div className="accordion-body">
                                  {faq.status === "Active"
                                    ? faq.answer
                                    : "Content not available."}
                                </div>
                              </div>
                            </div>
                          ))
                        ) : (
                          <div className="faq2">
                            <span className="faq_cate_span">
                              {t("NoFAQsAvailableForDeposit")}
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="recent_depo_main">
                <div className="manage_btn_row">
                  <span className="home_right_marketspan">
                    {t("RecentWithdraw")}
                  </span>
                  <Link to="/withdrawhistory">
                    <div className="d-flex align-items-center gap-2 cursor-pointer">
                      <span className="home_starty_view">{t("ViewAll")}</span>
                      <i class="fa-solid fa-chevron-right home_starty_viewarrow"></i>
                    </div>
                  </Link>
                </div>
                <div className="recent_depo_tablemain pb-0">
                  <div className="table-responsive table-borderless home_recent_table">
                    {loading ? (
                      <div className="loader_main loader_mainChange">
                        <ScaleLoader color="#20A1FD" height={10} width={3} />
                        <p>{t("Loading")}</p>
                      </div>
                    ) : (
                      <table className="table">
                        <thead>
                          <tr>
                            <th className="text_left">{t("Currency")}</th>
                            <th>{t("Date&Time")}</th>
                            <th>{t("Network")}</th>
                            <th>{t("Amount")}</th>
                            <th>{t("TransactionID")}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {withdrawalHistory.length > 0 ? (
                            withdrawalHistory
                              .slice(0, 5)
                              .map((withdrawal, index) => (
                                <tr key={index}>
                                  <td>
                                    <div className="home_recent_firstdata">
                                      <img
                                        src={require("../assests/usdt-logo.png")}
                                        alt="usdt"
                                        className="usdt_home_recent"
                                      />
                                      <span>{withdrawal.currency}</span>
                                    </div>
                                  </td>
                                  <td>
                                    <span>
                                      {isNaN(new Date(withdrawal.date))
                                        ? "null"
                                        : dayjs(withdrawal.date).format(
                                            "DD MMMM YYYY, hh:mm A"
                                          )}
                                    </span>
                                  </td>
                                  <td>
                                    <span>{withdrawal.network}</span>
                                  </td>
                                  <td>
                                    <span>{withdrawal.amount}</span>
                                  </td>
                                  <td>
                                    <div className="home_uid_main">
                                      <span>
                                        {withdrawal.txID &&
                                        withdrawal.txID !== "Pending"
                                          ? truncateText(withdrawal?.txID, 10)
                                          : withdrawal.transactionId &&
                                            withdrawal.transactionId !==
                                              "Pending"
                                          ? truncateText(
                                              withdrawal?.transactionId,
                                              10
                                            )
                                          : "-"}
                                      </span>
                                      {(withdrawal.txID &&
                                        withdrawal.txID !== "Pending") ||
                                      (withdrawal.transactionId &&
                                        withdrawal.transactionId !==
                                          "Pending") ? (
                                        <i
                                          className="ri-file-copy-line cursor-pointer uid_copy_recent"
                                          onClick={() =>
                                            handleCopy(
                                              withdrawal.txID ||
                                                withdrawal.transactionId
                                            )
                                          }
                                        ></i>
                                      ) : null}
                                    </div>
                                  </td>
                                </tr>
                              ))
                          ) : (
                            <tr>
                              <td colSpan="5">
                                <span className="depo_no_record">
                                  {t("NoTransactionsFound")}
                                </span>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Withdraw;
